import api from './index'
import { electronLatest } from '../renderer/constants/apis'

// 获取最新版本
const getAppLatest = () => {
  return new Promise((resolve, reject) => {
    api.call('GET', electronLatest, {}, (res) => {
      resolve(res)
    })
  })
}

export { getAppLatest }
